// 3rd Party
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import {
  Div,
  H3,
  P,
  Span,
  VisuallyHidden,
} from 'common/styles/oc-styled-components';

import { colors } from 'common/styles/style-constants';

import {
  useWindowDimensions,
  DIMENSIONS,
} from 'providers/WindowDimensionsProvider';

import { ConfirmationSubHeading } from '../../../checkout-styled-components';

// Other
import { selectRequestedSlot, selectReason } from '../../../connect/selectors';
import { getTimeFromStartTime } from '../../../../common/helpers/appointment-slot-helpers';

// Component
const AppointmentCard = () => {
  const selectedSlot = useSelector(selectRequestedSlot);
  const selectedSlotDateReadable = moment(selectedSlot.date).format('MMMM Do');
  const selectedSlotTimeReadable = getTimeFromStartTime(
    selectedSlot.time,
    'h:mm A',
  );
  const appointmentReason = useSelector(selectReason);
  const { layout } = useWindowDimensions();

  return (
    <>
      <ConfirmationSubHeading
        color={colors.sageDark}
        aria-hidden
        margin={`${layout === DIMENSIONS.MOBILE ? ' -1.25em 0 0' : ''}`}
      >
        Preferred Appointment Time
      </ConfirmationSubHeading>
      <Div
        margin={`${
          layout === DIMENSIONS.MOBILE ? '.5em 0 5px' : '15px 0 10px'
        }`}
      >
        <H3 margin="0" fontSize="18px" fontWeight="600">
          {selectedSlotDateReadable}
          {' '}
          <Span fontSize="14px" color={colors.slate}>
            at
          </Span>
          {' '}
          {selectedSlotTimeReadable}
        </H3>
        <P className="sensitive-data" color={colors.slate}>
          <VisuallyHidden>Reason for visit:</VisuallyHidden>
          {appointmentReason}
        </P>
      </Div>
    </>
  );
};

export default AppointmentCard;
